module.exports = __webpack_public_path__ + "img/img13.45400066.svg";